import { AFDataObject, AFMessageType } from ".";

export interface RankingRawData {
  cumulativeConvictionAtCurrentTime: number;
  peakConvictionUpToCurrent: number;
  cumulativeConvictionAtSameTimeRank: number;
  cumulativeConvictionRankSampleCount: number;
  peakConvictionRank: number;
  peakConvictionRankSampleCount: number;
  timeToReachTargetConvictionRank: number;
  timeToReachTargetConvictionRankSampleCount: number;
}

export interface RankingStateData extends RankingRawData {
  lastUpdated: Date;
}

export class Ranking implements AFDataObject<RankingRawData, RankingStateData> {
  public cumulativeConvictionAtCurrentTime: number;
  public peakConvictionUpToCurrent: number;
  public cumulativeConvictionAtSameTimeRank: number;
  public cumulativeConvictionRankSampleCount: number;
  public peakConvictionRank: number;
  public peakConvictionRankSampleCount: number;
  public timeToReachTargetConvictionRank: number;
  public timeToReachTargetConvictionRankSampleCount: number;
  public lastUpdated: Date;

  constructor(data: RankingRawData | RankingStateData | null, lastUpdated?: Date) {
    // 기본값 설정
    this.cumulativeConvictionAtCurrentTime = data?.cumulativeConvictionAtCurrentTime || 0;
    this.peakConvictionUpToCurrent = data?.peakConvictionUpToCurrent || 0;
    this.cumulativeConvictionAtSameTimeRank = data?.cumulativeConvictionAtSameTimeRank || 0;
    this.cumulativeConvictionRankSampleCount = data?.cumulativeConvictionRankSampleCount || 0;
    this.peakConvictionRank = data?.peakConvictionRank || 0;
    this.peakConvictionRankSampleCount = data?.peakConvictionRankSampleCount || 0;
    this.timeToReachTargetConvictionRank = data?.timeToReachTargetConvictionRank || 0;
    this.timeToReachTargetConvictionRankSampleCount = data?.timeToReachTargetConvictionRankSampleCount || 0;
    this.lastUpdated = new Date(lastUpdated || 0);
  }

  static create(data: RankingRawData | RankingStateData | null, lastUpdated?: Date): Ranking {
    return new Ranking(data, lastUpdated);
  }

  getMessageType(): AFMessageType {
    return AFMessageType.AF_RANK;
  }

  toRawData(): RankingRawData {
    return {
      cumulativeConvictionAtCurrentTime: this.cumulativeConvictionAtCurrentTime,
      peakConvictionUpToCurrent: this.peakConvictionUpToCurrent,
      cumulativeConvictionAtSameTimeRank: this.cumulativeConvictionAtSameTimeRank,
      cumulativeConvictionRankSampleCount: this.cumulativeConvictionRankSampleCount,
      peakConvictionRank: this.peakConvictionRank,
      peakConvictionRankSampleCount: this.peakConvictionRankSampleCount,
      timeToReachTargetConvictionRank: this.timeToReachTargetConvictionRank,
      timeToReachTargetConvictionRankSampleCount: this.timeToReachTargetConvictionRankSampleCount,
    };
  }

  toStateData(): RankingStateData {
    const processedData = {
        cumulativeConvictionAtCurrentTime: this.cumulativeConvictionAtCurrentTime,
        peakConvictionUpToCurrent: this.peakConvictionUpToCurrent,
        cumulativeConvictionAtSameTimeRank: Number((this.cumulativeConvictionAtSameTimeRank * 100).toFixed(2)),
        cumulativeConvictionRankSampleCount: this.cumulativeConvictionRankSampleCount,
        peakConvictionRank: Number((this.peakConvictionRank * 100).toFixed(2)),
        peakConvictionRankSampleCount: this.peakConvictionRankSampleCount,
        timeToReachTargetConvictionRank: Number((this.timeToReachTargetConvictionRank * 100).toFixed(2)),
        timeToReachTargetConvictionRankSampleCount: this.timeToReachTargetConvictionRankSampleCount,
      };
    return {
      ...processedData,
      lastUpdated: this.lastUpdated
    };
  }

  filter(existingData: RankingStateData): boolean {
    return Number(this.lastUpdated) > Number(existingData.lastUpdated);
  }
}
